import { render, staticRenderFns } from "./CalidadTipos.vue?vue&type=template&id=bba2cf2c&"
import script from "./CalidadTipos.vue?vue&type=script&lang=js&"
export * from "./CalidadTipos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports